import React, { useEffect, useState } from 'react';
import andLogo from './../and-logo.png';

import { AwesomeQRCode } from '@awesomeqr/react';
import generateLink from '../Common/generateLink';
import Typography from '@mui/joy/Typography';
import Stack from '@mui/joy/Stack';
import Box from '@mui/joy/Box';
import { BasicProfile, getMeta } from '../../utils/qr';
import FlexibleAppButtons from '../Common/FlexibleAppButtons';

const fsImageAsDataURI = async (path) => {
  const blob = await fetch(path).then((res) => res.blob());
  const reader = new FileReader();
  return await new Promise((resolve, reject) => {
    reader.onerror = reject;
    reader.onload = () => resolve(reader.result);
    return reader.readAsDataURL(blob);
  });
};

export interface ConnectModalDialogProps {
  basicProfile: BasicProfile;
  queryParams: URLSearchParams;
  actionOverride?: string;
}

export default function ConnectModalDialog({
  basicProfile,
  queryParams,
  actionOverride,
}: ConnectModalDialogProps) {
  const meta = getMeta(basicProfile, queryParams, actionOverride);
  const [backgroundImage, setBackgroundImage] = useState<string>('');
  const [isDesktop, setIsDesktop] = useState<boolean>(false);

  useEffect(() => {
    async function getImageAsDataURI() {
      const dataURI = (await fsImageAsDataURI(andLogo)) as string;
      setBackgroundImage(dataURI);
    }
    getImageAsDataURI();
  }, []);

  useEffect(() => {
    const isMobile = navigator.userAgent.match(
      /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i
    );

    setIsDesktop(!isMobile);
  }, []);

  if (!meta) {
    return null;
  }

  return (
    <Stack spacing={2}>
      {isDesktop ? (
        <>
          <Typography level="h3" sx={{ color: '#545454' }}>
            Scan with your phone
          </Typography>
          <Typography>{meta.detail}</Typography>
          <Box
            sx={{
              width: 'auto',
              height: 300,
              py: 3,
            }}
          >
            {backgroundImage && (
              <AwesomeQRCode
                options={{
                  text: generateLink(basicProfile.andTag),
                  size: 200,
                  margin: 0,
                  autoColor: true,
                  backgroundImage,
                }}
              />
            )}
          </Box>
        </>
      ) : (
        <FlexibleAppButtons />
      )}
    </Stack>
  );
}
